import logo from './logo.svg';
import BetterLessonLogo from './images/betterlesson.svg';
// import styles from './styles.css';
import styles from './App.module.css';
import buttonStyles from './Button.module.css';
// import BetterLessonLogo from '@images/betterlesson.svg';
import './App.css';

function App() {
  console.log(styles);
  return (
    <div className={styles.container}>
      <div className={styles.formContainer}>
        <div className={styles.formContent}>
          <img style={{ maxWidth: '60%', margin: '10px 0 30px 0' }}
            src={BetterLessonLogo}
          // className={styles.container}
          // data-testid="betterlesson-logo"
          />
          <div className={styles.headerText}>
            The BetterLesson Community site is sunsetting on
            March 4th, 2022
          </div>
          <br />
          <div className={styles.subHeaderText}>
            Since our founding in 2008, we've learned a lot alongside the millions
            of educators who've grown up with us. We are so proud of the
            community that generously rallied around BetterLesson and
            contributed thousands of resources to our platform. Over time, we've
            scaled the original vision of our community site into&nbsp;
            <span className={styles.subHeaderTextBlue} >
                <a href='https://teaching.betterlesson.com/browse/master_teachers/projects' className={styles.subHeaderTextBlue}>
                thousands of proven, research-based K-12 Lesson plans&nbsp;
                  </a>
              </span>
            and&nbsp;
            <span className={styles.subHeaderTextBlue}>
              <a href='https://teaching.betterlesson.com/browse/strategies' className={styles.subHeaderTextBlue}>instructional strategies&nbsp;</a>
            </span>
            from our Master Teachers.
          </div>
            
              <div className={styles.subHeaderText}>
                These strategies serve as the foundation for actionable and
              personalized professional learning experiences, and will continue to
            be available to everyone after March 4th.
              </div>
          <div className={styles.subHeaderText}>
            We are committed to the continued growth of&nbsp;
            <span className={styles.subHeaderTextBlue} >
                <a href='https://teaching.betterlesson.com/browse/strategies' className={styles.subHeaderTextBlue}>this free library&nbsp;</a>
              </span>
              and are proud to ensure that every teacher, everywhere, can count on us
              for high-quality, trusted content.
            </div>
          <div
          className={`${buttonStyles.container} ${buttonStyles.defaultButton}`}
        onClick={() => {
          window.location.replace('https://teaching.betterlesson.com/browse/strategies');
          return null;
        }}>
        <a href='https://teaching.betterlesson.com/browse/strategies'
          className={buttonStyles.content}
        // style={{ minWidth: contentMinWidth }}
        >
          {/* {leadingIcon && (
                <img
                  // src={leadingIcon}
                  className={buttonStyles.leadingIcon}
                />
              )} */}
          <span className={buttonStyles.text}>Explore Instructional Resources</span>
        </a>
      </div>
    </div>
      </div >
    </div >
  );
}

export default App;
